import React from "react";
import {
    Box,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    Typography,
} from "@mui/material";
import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme) => {
    return {
        main: {
            "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "#c4c4c4 !important",
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: "#c4c4c4 !important",
            },
            "&.Mui-disabled .MuiOutlinedInput-notchedOutline": {
                borderColor: "#c4c4c4 !important",
            },
            "&:focus .MuiOutlinedInput-notchedOutline": {
                borderColor: "#c4c4c4 !important",
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: "#c4c4c4 !important",
                borderWidth: "1px",
            },
            "&.Mui-disabled:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: "#c4c4c4 !important",
            },
            ".MuiSelect-select": {
                padding: "8px",
            },
            "input": {
                padding: "6px 12px 6px 12px",
                color: "#3E4095",
            },
            "input::placeholder": {
                color: "#7d7d7d",
                opacity: 1,
            },

        },
    };
});

const CommonDropDown = ({
    text,
    height,
    width,
    values,
    valid,
    onChange,
    name,
    value,
    labelColor,
    defaultValue,
    defaultChecked,
    disabled,
    fontWeight,
    labelSize,
    whiteSpace,
    className,
    renderOption,
    borderRadius,
    notShowSelect,
    subText
}) => {
    const { classes } = useStyles();

    return (
        <>
            {text && (
                <Box mb={0.5} display="flex" fontSize="12px" flexDirection={"row"}>
                    <Box display="flex" fontSize="12px" flexDirection={"column"} flexWrap={"wrap"} >
                        <InputLabel
                            sx={{
                                letterSpacing: "0.03em",
                                marginRight: "2px",
                                fontWeight: fontWeight,
                                fontSize: labelSize || "14px",
                                color: labelColor || "#222222",
                                whiteSpace: whiteSpace ? "wrap" : "nowrap",
                            }}
                        >
                            {text}
                        </InputLabel>
                        {subText && <InputLabel
                            sx={{
                                letterSpacing: "0.03em",
                                marginRight: "2px",
                                fontWeight: fontWeight,
                                fontSize: "11px",
                                color: labelColor || "#222222",
                                whiteSpace: whiteSpace ? "wrap" : "nowrap",
                            }}
                        >
                            {subText}
                        </InputLabel>}
                    </Box>
                    {valid && (
                        <Typography color="#EF627A" component={"span"} variant={"body2"}>
                            *
                        </Typography>
                    )}
                </Box>
            )}
            <FormControl sx={{
                width: width || "100%",
                height: height || "36px",
                "& .MuiOutlinedInput-root": {
                    borderRadius: borderRadius || "10px",
                    height: height || "36px",
                },
            }}>
                <Select
                    fullWidth
                    className={`${classes?.main} ${className}`}
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={value ? value === "Passport" ? value + " - File Number" : value : ""}
                    onChange={onChange}
                    name={name}
                    defaultValue={defaultValue || ""}
                    defaultChecked={defaultChecked}
                    disabled={disabled}
                    displayEmpty
                    renderValue={(selected) => {
                        if (selected === "") {
                            return <span style={{ color: "#a9a9a9" }}>Select</span>;
                        }
                        return selected;
                    }}
                >
                    {notShowSelect ? <></> :
                        <MenuItem value="">
                            <em>Select</em>
                        </MenuItem>}
                    {values &&
                        values.map((val, index) => {
                            return (
                                <MenuItem value={val} key={index.toString()}>
                                    {val} {val == "Passport" && " - File Number"}
                                </MenuItem>
                            );
                        })}
                    {renderOption &&
                        renderOption.map((val, index) => (
                            <MenuItem value={val.value} key={index}>
                                <span
                                    style={{
                                        display: "inline-block",
                                        width: "15px",
                                        height: "15px",
                                        backgroundColor: val.value,
                                        marginRight: "10px",
                                        borderRadius: "50%",
                                    }}
                                ></span>
                                {val.label}
                            </MenuItem>
                        ))}
                </Select>
            </FormControl>
        </>
    );
};

export default CommonDropDown;